import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import familyFestFaqCategoryApi from '@infrastructure/family-fest-faq-category-api';
export const getFamilyFestFaqCategoriesAsync = createAsyncThunk('familyFestFaqCategory/getAll', async (_, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqCategoryApi.getFamilyFestFaqCategories();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
// The FAQs tab list for one type; stored as the slice's `categories`.
export const getFamilyFestFaqCategoriesByTypeAsync = createAsyncThunk('familyFestFaqCategory/getByType', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqCategoryApi.getFamilyFestFaqCategoriesByType(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
// Same request for the FAQ dialogs' category dropdown; not stored, so it never replaces the list.
export const getFamilyFestFaqCategoryOptionsByTypeAsync = createAsyncThunk('familyFestFaqCategory/getOptionsByType', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqCategoryApi.getFamilyFestFaqCategoriesByType(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFamilyFestFaqCategoryByIdAsync = createAsyncThunk('familyFestFaqCategory/getById', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqCategoryApi.getFamilyFestFaqCategoryById(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createFamilyFestFaqCategoryAsync = createAsyncThunk('familyFestFaqCategory/create', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqCategoryApi.createFamilyFestFaqCategory(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateFamilyFestFaqCategoryAsync = createAsyncThunk('familyFestFaqCategory/update', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqCategoryApi.updateFamilyFestFaqCategory(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteFamilyFestFaqCategoryAsync = createAsyncThunk('familyFestFaqCategory/delete', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqCategoryApi.deleteFamilyFestFaqCategory(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const reorderFamilyFestFaqCategoriesAsync = createAsyncThunk('familyFestFaqCategory/reorder', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqCategoryApi.reorderFamilyFestFaqCategories(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
